import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    ViewChild,
    ElementRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { BusinessOwnerService } from 'src/app/acl-data/business-owner/business-owner.service';

@Component({
    templateUrl: './bo-upload.component.html',
    styleUrls: ['./bo-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BOUploadComponent {
    @ViewChild('fileSelector', { static: true }) fileSelector;

    public uploader: FileUploader = new FileUploader({
        url: environment.boUploadURL,
        isHTML5: true,
        disableMultipart: false,
        // allowedMimeType: ['application/zip'],
    });

    uploading$ = new BehaviorSubject(false);
    errorDownloadable = new BehaviorSubject(false);
    lastError = null;
    uploadFailed = false;
    filename = '';
    file;
    zipFile = false;
    constructor(
        public dialogRef: MatDialogRef<BOUploadComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cdr: ChangeDetectorRef,
        private businessOnwerService: BusinessOwnerService
    ) {
        this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
            console.log('Added file:', fileItem);

            // fileItem._xhr.responseType = 'arraybuffer';
            // fileItem.headers = [
            //     {
            //         name: 'Content-Type',
            //         value:
            //             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            //     },
            // ];
            this.filename = fileItem.file.name;
            const sizeValue = fileItem.file.size;
            this.file = fileItem.file.rawFile;
            this.errorDownloadable.next(false);
            this.lastError = null;
            this.uploadFailed = false;
            console.log(fileItem);
        };

        this.uploader.onSuccessItem = () => {
            // const folder = this.data.folder;
            // const objectStore = this.data.objectStore;
            window.location.reload(); //Make sure we reload all the folders, including sub folders
            //TODO: This should realy be a service call...
        };

        this.uploader.onErrorItem = (
            item: FileItem,
            response: any,
            status: number,
            headers: ParsedResponseHeaders
        ) => {
            console.log('Failed');
            this.uploadFailed = true;
            this.uploading$.next(false);
            this.uploader.clearQueue();
            this.cdr.detectChanges();
            console.log('Error Code:', status);

            if (status === 400) {
                this.lastError = response;
                // console.log(response);
                this.errorDownloadable.next(true);
            }
        };

        if (this.data.file) {
            console.log('We have a file');
            this.uploader.addToQueue([this.data.file]);
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    upload() {
        this.uploading$.next(true);
        this.lastError = null;
        this.errorDownloadable.next(false);
        // this.uploader.uploadAll();
        const data = this.fileSelector.nativeElement.files[0];
        this.businessOnwerService.upload(data).subscribe(
            v => {
                console.log('Uploaded Success:', v);
                // const folder = this.data.folder;
                // const objectStore = this.data.objectStore;
                window.location.reload(); //Make sure we reload all the folders, including sub folders
                //TODO: This should realy be a service call...
            },
            error => {
                console.log('Error', error);
                this.uploadFailed = true;
                this.uploading$.next(false);
                this.uploader.clearQueue();
                this.cdr.detectChanges();
                console.log('Error Code:', error.status);

                if (error.status === 400) {
                    const buffer = error.error;
                    this.lastError = [
                        new Uint8Array(buffer, 0, buffer.byteLength),
                    ];
                    // console.log(response);
                    this.errorDownloadable.next(true);
                }
            }
        );
    }

    downloadError() {
        console.log('Downloading Error');
        // console.log();
        this.downLoadFile(
            this.lastError,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Business Owner Master Data Errors.xlsx'
        );
    }

    /**
     * Method is use to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     */
    downLoadFile(data: any, typeValue: string, filename: string) {
        console.log('Download Data', data);
        // const blob = new Blob([data], { type: typeValue });
        // const url = window.URL.createObjectURL(blob);
        // window.location.href = url;

        const a = document.createElement('a');
        document.body.appendChild(a);
        // a.style = 'display: none';

        const blob = new Blob(data, { type: typeValue });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        // const pwa = window.open(url);
        // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
        //     alert('Please disable your Pop-up blocker and try again.');
        // }
    }
}
